import React, { createContext, useContext, useState } from 'react';
import { Location } from '../../location/LocationStep';

interface LocationPanel {
  type: 'location';
  data: Location;
}

// Union — extend here as other steps get split-screen context panels
export type ContextPanel = LocationPanel | null;

interface SplitScreenContextValue {
  contextPanel: ContextPanel;
  setContextPanel: (panel: ContextPanel) => void;
  allLocations: Location[];
  setAllLocations: (locations: Location[]) => void;
}

const SplitScreenContext = createContext<SplitScreenContextValue>({
  contextPanel: null,
  setContextPanel: () => {},
  allLocations: [],
  setAllLocations: () => {},
});

export const useSplitScreen = () => useContext(SplitScreenContext);

export const SplitScreenProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [contextPanel, setContextPanel] = useState<ContextPanel>(null);
  const [allLocations, setAllLocations] = useState<Location[]>([]);

  return (
    <SplitScreenContext.Provider value={{ contextPanel, setContextPanel, allLocations, setAllLocations }}>
      {children}
    </SplitScreenContext.Provider>
  );
};
